import { States } from "..";

export function getVersion(states:States){
   return states.appGlobal.version;
}

export function getUrlVideo(states:States){
   return states.appGlobal.urlVideo;
}